import { styled } from '@mui/system'
import Switch, { SwitchProps } from '@mui/material/Switch'

const StyledToggle = styled((props: SwitchProps) => (
  <Switch disableRipple {...props} />
))(() => ({
  '& .MuiSwitch-switchBase': {
    '&:hover': {
      // hide the hover ripple outline
      backgroundColor: 'transparent'
    }
  },
  '& .MuiSwitch-track': {
    opacity: '0.16'
  }
}))

export default StyledToggle
